import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'contactVerification',
    standalone: false
})
export class ContactVerificationPipe implements PipeTransform {
  private static readonly BOTH_VERIFIED = 'Email Verified and Machine Verified';
  private static readonly MACHINE_VERIFIED = 'Machine Verified';
  private static readonly EMAIL_VERIFIED = 'Email Verified';

  transform(initialData: {
    hasEVAndMV: boolean;
    hasMV: boolean;
    expressRod: boolean;
    hasEV: boolean;
  }): string {
    if (initialData.hasEVAndMV) {
      return ContactVerificationPipe.BOTH_VERIFIED;
    } else if (initialData.hasMV || initialData.expressRod) {
      return ContactVerificationPipe.MACHINE_VERIFIED;
    } else if (initialData.hasEV) {
      return ContactVerificationPipe.EMAIL_VERIFIED;
    } else {
      return ContactVerificationPipe.BOTH_VERIFIED;
    }
  }
}
